import { BaseTextMergeEditor } from "./BaseTextMergeEditor";
import React, { useState } from "react";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { Box, Link } from "@mui/material";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import { UILabel } from "../../CommonUI/BuildlingBlocks/UILabel";
import { UIStandardLayer } from "../../CommonUI/BuildlingBlocks/UIStandardLayer";
import { TextSubstitutionEditor } from "../TextSubsitution/TextSubstitutionEditor";
import { HTMLDisplayType, UIHTMLDisplay } from "../../CommonUI/BuildlingBlocks/UIHTMLDisplay";
import { BaseTextMergeElement } from "../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";
import { TextMergeEditContext } from "../../rule-engine-core/TextMerge/TextMergeEditContext";
import { SubstitutionTextElement } from "../../rule-engine-core/TextMerge/Elements/SubstitutionTextElement";
import { StateManager } from "../../rule-engine-core/Common/StateManager";

export class SubstitutionTextElementEditor extends BaseTextMergeEditor<SubstitutionTextElement> {
    renderDisplay(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        return (
            <>
                <span
                    style={
                        editContext.selectedElement?.id === this.getEditorData().id
                            ? { background: UIStyleConstants.BLUE_LIGHT_COLOR }
                            : {}
                    }
                    onClick={() => {
                        editContext.setSelectedElement(config);
                    }}
                >
                    <UIHTMLDisplay
                        html={this.editorData!.configuration.text}
                        displayType={HTMLDisplayType.span}
                    />
                </span>
            </>
        );
    }

    renderEditor(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        return (
            <SubEditor
                config={config}
                editorData={this.editorData!}
                editContext={editContext}
            />
        );
    }

    getIcon(): JSX.Element {
        return <FormatAlignJustifyIcon />;
    }
}

function SubEditor(props: {
    config: BaseTextMergeElement;
    editorData: SubstitutionTextElement;
    editContext: TextMergeEditContext;
}) {
    let [showEditor, setShowEditor] = useState<boolean>(false);

    return (
        <Box
            padding={"3px"}
            margin={"3px"}
            bgcolor={"white"}
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            border={props.editContext.selectedElement?.id === props.config.id ? "2px solid red" : "1px solid blue"}
            onClick={() => {
                props.editContext.setSelectedElement(props.config);
            }}
        >
            {!props.editorData?.configuration.text && <UILabel>[substitution]</UILabel>}
            {props.editorData?.configuration.text && props.editorData?.configuration.text?.length > 200
                ? props.editorData?.configuration.text?.substring(0, 200) + " ..."
                : props.editorData?.configuration.text}

            <Link onClick={() => setShowEditor(true)}>Edit</Link>
            {showEditor && (
                <UIStandardLayer
                    fullScreen={true}
                    open={showEditor}
                    title={"substitution TextEditor"}
                    primaryActionText={"Done"}
                    onPrimaryAction={() => {
                        setShowEditor(false);
                        StateManager.changed(props.config);
                    }}
                    onClose={() => {
                        setShowEditor(false);
                        StateManager.changed(props.config);
                    }}
                    renderUI={() => {
                        return <TextSubstitutionEditor config={props.editorData!.configuration} />;
                    }}
                />
            )}
        </Box>
    );
}
